<template>
  <v-col class="fill-height overflow-auto">
    <v-row
      v-if="images.length <= 0"
      class="mt-2"
    >
      <v-col class="text-center grey--text">
        <v-icon
          size="30"
          color="grey"
          >mdi-image-multiple-outline</v-icon
        >
        <div class="text-info mt-2">{{ $t("messages.information.no_picture_available") }}</div>
      </v-col>
    </v-row>

    <v-row
      v-else
      class="pa-2 pr-3"
    >
      <v-col
        class="pa-1"
        cols="6"
        v-for="(image, i) in images"
        :key="i"
      >
        <ImageCaptureItem
          :image="image"
          @deleted="onCaptureItemDeleted"
        />
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
import ImageCaptureItem from "@/components/video-meeting/side-bar/activities/ImageCaptureItem.vue"
import InspectionService from "@/services/InspectionService"

export default {
  name: "ImageCapture",
  components: {
    ImageCaptureItem
  },
  props: {
    inspection: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      images: []
    }
  },
  methods: {
    fetchImages() {
      const inspectionId = this.inspection.id
      InspectionService.unassignedPictures.getAll(inspectionId).then(response => {
        this.images = response.results
      })
    },
    onCaptureItemDeleted() {
      this.fetchImages()
      this.$store.commit("app/message", {
        msg: this.$t("messages.success.deleted", {
          entity: this.$tc("commons.picture", 1)
        }),
        color: "success"
      })
    }
  },
  mounted() {
    this.fetchImages()
  }
}
</script>

<style scoped>
.d-relative {
  position: relative;
}
</style>
